import { CATEGORY_GAME } from "contants/game-type";
import { PATH } from "contants/path";
import { useAppDispatch, useAppSelector } from "hooks/app-hook";
import { useEffect } from "react";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { selectCategoryGameList } from "store/game";
import { getGameList } from "store/game/game.thunk";
import {
  CategoryGameListType,
  CategoryGameType,
  GameListResponseType,
} from "types/game";

import StyledHeaderLinkGames from "./index.style";

const HeaderLink = () => {
  const { categoryId } = useParams();
  const { pathname: pathCategory } = useLocation();

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const categoryGameList = useAppSelector(selectCategoryGameList);

  useEffect(() => {
    if (!categoryId) return;

    if (pathCategory.includes(categoryId) && categoryGameList.length > 0)
      return;

    const findCategoryGame = CATEGORY_GAME.find((category: CategoryGameType) =>
      category.path.includes(`/${categoryId}`)
    );

    if (!findCategoryGame) return;

    dispatch(getGameList(findCategoryGame.id));
  }, [categoryId, pathCategory, categoryGameList.length]);

  const handleAction = async (categoryGame: CategoryGameType) => {
    const res = await dispatch(getGameList(categoryGame.id));

    const dataRes = res.payload as GameListResponseType;
    const { data: listGame } = dataRes;

    if (!listGame.length) return;
    const findGame = listGame.find(
      (game: CategoryGameListType) => game.provider_name
    );

    if (!findGame) return;
    navigate(`${categoryGame.path}/${findGame.provider_code}`);
  };
  return (
    <StyledHeaderLinkGames>
      <ul>
        {CATEGORY_GAME.map((categoryGame: CategoryGameType) => (
          <li className="header-menu-main__popular" key={categoryGame.id}>
            <div className="item" onClick={() => handleAction(categoryGame)}>
              {categoryGame.name}
            </div>
          </li>
        ))}
      </ul>
      <ul>
        <li className="header-menu-main__popular">
          <NavLink className="item" to={PATH.newsPage}>
            News
          </NavLink>
        </li>
        <li className="header-menu-main__popular">
          <NavLink className="item" to={PATH.bonusPage}>
            Bonuses
          </NavLink>
        </li>
        <li className="header-menu-main__popular">
          <NavLink className="item" to={PATH.tournamentsPage}>
            Tournaments
          </NavLink>
        </li>
      </ul>
    </StyledHeaderLinkGames>
  );
};

export default HeaderLink;
